<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent" id="ch00_fm05_ded"><a id="page_v"></a><strong>This book is dedicated to the greatest salesman who ever lived.</strong> He was a man who could change a mind in a heartbeat, with the skill of a surgeon. What I learned, I learned from him, and what I write, I write for him. Xerox taught me how, but he taught me why. He was my father. Rest easy, Lion Lee Jolles; your voice and words will never be forgotten.<a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05_ded.vue?c987c912